import * as React from 'react';

export interface NoActiveDevicePromptProps {
    isVisible: boolean;
    triggerCantFindDeviceDialog: () => void;
    children: React.ReactNode;
}

export interface NoActiveDevicePromptState {
    showCannotFindDevice: boolean;
}

export const NoActiveDevicesPrompt = (props: NoActiveDevicePromptProps) => {
    if (props.isVisible) {
        return (
            <>
                <div className="col-md-12">
                    <div className="alert alert-warning">
                        No Active devices found. <a id="cannot-find-device" onClick={props.triggerCantFindDeviceDialog}>Can't find your device?</a>
                    </div>
                    <p>The Web Portal will automatically attempt to reconnect every 15 seconds</p>
                </div>
                {props.children}
            </>
        );
    } else {
        return null;
    }
}
